var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfitEuro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Euro-Up",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profit-Up",
    fill: "#E8F9ED"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    cx: 20,
    cy: 20,
    r: 20
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22,17 L22,19 L15.071,19 C14.987,19.664 14.987,20.336 15.071,21 L22,21 L22,23 L15.591,23 C16.733,25.783 19.534,28 24,28 L26,28 L26,30 L24,30 C18.155,30 14.647,26.821 13.461,23 L10,23 L10,21 L13.052,21 C12.986,20.335 12.986,19.665 13.052,19 L10,19 L10,17 L13.461,17 C14.647,13.179 18.155,10 24,10 L26,10 L26,12 L24,12 C19.534,12 16.733,14.217 15.591,17 L22,17 Z",
    id: "euro-[#1188]",
    fill: "#39C258"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitEuro);
export default __webpack_public_path__ + "static/media/profit-euro.a8e80d67.svg";
export { ForwardRef as ReactComponent };